import { useSyncExternalStore } from 'react';

/**
 * Aktiver Mandant (Slug) — als Mini-Store außerhalb von React, weil auch
 * der API-Client (X-Tenant-Header) ihn lesen muss. Persistiert in localStorage.
 */
const STORAGE_KEY = 'aurora.tenant';

let current: string | null = localStorage.getItem(STORAGE_KEY);
const listeners = new Set<() => void>();

export const tenantStore = {
  get(this: void): string | null {
    return current;
  },
  set(this: void, slug: string | null): void {
    current = slug;
    if (slug === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, slug);
    for (const listener of listeners) listener();
  },
  subscribe(this: void, listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useTenantSlug(): string | null {
  return useSyncExternalStore(tenantStore.subscribe, tenantStore.get);
}
